function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2758 20.0919L15.0337 22.2625L10.0813 13.4824L0 13.5829L3.76043 15.7524L0.742467 20.9786C0.4366 21.5077 0.1147 22.3649 0.561167 23.1394L5.68443 32.0114C6.60203 33.6012 8.20043 33.5919 9.35792 33.5919H17.546V24.0835H8.97065L11.2758 20.0919Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M36.1165 18.8923L32.0218 11.8013L23.7875 16.5545L28.0745 23.9804L23.4662 23.9798V19.6422L18.3398 28.3205L23.4687 37.0001L23.4674 32.6594H29.5003C30.112 32.6594 31.016 32.5096 31.4625 31.7363L36.5852 22.8643C37.5021 21.2733 36.6955 19.895 36.1165 18.8923Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.8471 6.81047L21.1504 10.8028L17.393 12.9734L27.4737 13.0727L32.4261 4.29138L28.6675 6.46267L25.6514 1.23765C25.3449 0.707933 24.7628 0 23.8705 0H13.6258C11.7894 0 10.9982 1.38873 10.4204 2.39143L6.32568 9.48248L14.56 14.2364L18.8471 6.81047Z",
  fill: "white"
});

function SvgEco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEco);
export default __webpack_public_path__ + "static/media/eco.6aec3a23.svg";
export { ForwardRef as ReactComponent };